import { CollectionEmptyPage } from './collectionEmpty';

export default CollectionEmptyPage;
